import { Tooltip, TooltipProps } from "@stenajs-webui/tooltip";

interface Props extends TooltipProps {
  shouldShow: boolean;
}

/**
 * A tooltip that only opens while shouldShow is true.
 *
 * The tooltip stays mounted either way. Rendering the children without it
 * would change the shape of the tree, which makes React throw away the
 * subtree and build a new one - a focused input would lose its focus every
 * time the condition flipped.
 */
export const ConditionalTooltip = ({
  shouldShow,
  visible,
  children,
  ...props
}: Props) => {
  return (
    <Tooltip {...props} visible={shouldShow ? visible : false}>
      {children}
    </Tooltip>
  );
};
